import { useSelector } from "react-redux";
import { CircleShadow as StyledCircleShadow } from "./styled";

export const CircleShadow = ({ releaseId, circleWidth }) => {
  const currentContent = useSelector((state) => state.player.currentContent);

  return (
    <StyledCircleShadow
      circleWidth={circleWidth}
      showShadow={currentContent?.id === releaseId}
    />
  );
};
